import { ConfigProvider } from "antd"
import "antd/dist/reset.css"
import { ErrorBoundary } from "components/custom"
import { configs } from "configs"
import themeV5 from "configs/themeV5"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import duration from "dayjs/plugin/duration"
import isBetween from "dayjs/plugin/isBetween"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import localeData from "dayjs/plugin/localeData"
import localizedFormat from "dayjs/plugin/localizedFormat"
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import relativeTime from "dayjs/plugin/relativeTime"
import utc from "dayjs/plugin/utc"
import weekday from "dayjs/plugin/weekday"
import weekOfYear from "dayjs/plugin/weekOfYear"
import weekYear from "dayjs/plugin/weekYear"
import { getAppLanguage } from "hooks/useLanguage"
import { useEffect, useMemo } from "react"
import { BrowserRouter } from "react-router-dom"
import AppRoutes from "routes"
import { inDevelopMode } from "utils/env"
import "./core/App.less"

dayjs.extend(advancedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(utc)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(quarterOfYear)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(localizedFormat)

const App = () => {
  const language = getAppLanguage()

  useEffect(() => {
    const htmlElement = document.getElementsByTagName("html")[0]
    htmlElement.lang = language?.locale
    htmlElement.dir = language?.rtl ? "rtl" : "ltr"
    
    const loadFont = () => {
      const existingFontLink = document.getElementById("link-app-fonts")
      if (existingFontLink) {
        existingFontLink.remove()
      }

      if (language?.font) {
        const fontLink = document.createElement("link")
        fontLink.id = "link-app-fonts"
        fontLink.href = language.font
        fontLink.rel = "stylesheet"
        document.head.appendChild(fontLink)
      }

      if (language?.fallbackFontInfo) {
        document.body.style.fontFamily = language.fallbackFontInfo
      }
    }

    loadFont()
  }, [language?.locale, language?.font, language?.fallbackFontInfo])

  const dynamicTheme = useMemo(() => {
    const baseTheme = { ...themeV5 }
    if (language?.fallbackFontInfo) {
      baseTheme.token.fontFamily = language.fallbackFontInfo
    }

    return baseTheme
  }, [language?.fallbackFontInfo])

  const renderPFRoutes = useMemo(() => {
    return inDevelopMode ? (
      <AppRoutes />
    ) : (
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    )
  }, [inDevelopMode])

  return (
    <ConfigProvider locale={language?.locale || "en"} direction={language?.rtl ? "rtl" : "ltr"} theme={dynamicTheme}>
      <BrowserRouter>
        {renderPFRoutes}
      </BrowserRouter>
    </ConfigProvider>
  )
}

export default App
